var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lexicon" },
    [
      _c(
        "input",
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.modelValue,
                expression: "modelValue",
              },
            ],
            class: {
              "form-control": true,
              loading: !_vm.posOptions || !_vm.wordOptions,
            },
            attrs: {
              type: "text",
              autocomplete: "off",
              id: _vm.inputId,
              name: _vm.inputId,
              placeholder: _vm.definition.displayName,
            },
            domProps: { value: _vm.modelValue },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.modelValue = $event.target.value
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      !_vm.wordOptions
        ? _c("span", { staticClass: "fa fa-spinner fa-spin text-muted" })
        : _vm._e(),
      _vm._v(" "),
      _vm.wordOptions && _vm.wordOptions.length
        ? _c("div", { staticStyle: { margin: "10px 0" } }, [
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: {
                  type: "button",
                  disabled:
                    _vm.selectedWords.length === _vm.renderedWords.length,
                },
                on: {
                  click: function ($event) {
                    return _vm.renderedWords.forEach(function (w) {
                      return (w.selected = w.count > 0)
                    })
                  },
                },
              },
              [_vm._v("Select all\n\t\t")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: { type: "button", disabled: !_vm.selectedWords.length },
                on: {
                  click: function ($event) {
                    return _vm.renderedWords.forEach(function (w) {
                      return (w.selected = false)
                    })
                  },
                },
              },
              [_vm._v("Deselect all\n\t\t")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.renderedWords, function (opt) {
        return _c(
          "label",
          {
            key: opt.id,
            class: { disabled: opt.count === 0 },
            staticStyle: {
              width: "10vw",
              "min-width": "150px",
              overflow: "hidden",
              "text-overflow": "ellipsis",
              "white-space": "nowrap",
            },
            attrs: {
              role: opt.count > 0 ? "button" : undefined,
              title: opt.word + " (" + opt.count + ")",
            },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: opt.selected,
                  expression: "opt.selected",
                },
              ],
              attrs: { type: "checkbox", disabled: opt.count === 0 },
              domProps: {
                value: opt,
                checked: Array.isArray(opt.selected)
                  ? _vm._i(opt.selected, opt) > -1
                  : opt.selected,
              },
              on: {
                change: function ($event) {
                  var $$a = opt.selected,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = opt,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && _vm.$set(opt, "selected", $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          opt,
                          "selected",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(opt, "selected", $$c)
                  }
                },
              },
            }),
            _vm._v(" " + _vm._s(opt.word)),
          ]
        )
      }),
      _vm._v(" "),
      _vm.wordOptions && _vm.wordOptions.length
        ? [
            _c("h4", [_vm._v("Limit to Part of Speech")]),
            _vm._v(" "),
            _vm._l(_vm.posOptions, function (checked, pos) {
              return _c(
                "label",
                {
                  key: pos,
                  staticStyle: {
                    width: "10vw",
                    "min-width": "150px",
                    overflow: "hidden",
                    "text-overflow": "ellipsis",
                    "white-space": "nowrap",
                  },
                  attrs: { role: "button" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.posOptions[pos],
                        expression: "posOptions[pos]",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      value: pos,
                      checked: Array.isArray(_vm.posOptions[pos])
                        ? _vm._i(_vm.posOptions[pos], pos) > -1
                        : _vm.posOptions[pos],
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.posOptions[pos],
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = pos,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(_vm.posOptions, pos, $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.posOptions,
                                pos,
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.posOptions, pos, $$c)
                        }
                      },
                    },
                  }),
                  _vm._v(" " + _vm._s(pos) + "\n\t\t"),
                ]
              )
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }